// react
import { Map } from "immutable";
// dependencies
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

import { ProgressBar } from "@performyard/py-components";

// components
import Icon from "../../../components/Icon";
// config
import Config from "./Config";
import CompletedAction from "./components/CompletedAction";
import RunningIndicator from "./components/Indicator/running";

// actions
import { getJob, initialize } from "./actions";

// selectors
import { getIsDebug } from "../../../selectors/app";
import { getActiveSingleJob, getNonActiveSingleJob } from "./selectors";

import PropTypes from "../../../lib/prop-types";

// style
import "./style.scss";

export class ViewSingleJobPage extends React.Component {
	static propTypes = {
		job: PropTypes.instanceOf(Map),
		getJob: PropTypes.func.isRequired,
		init: PropTypes.func.isRequired,
		isUsingActiveJob: PropTypes.bool.isRequired,
		isDebug: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		job: null,
	};

	state = {
		lastJobCount: 0, // eslint-disable-line react/no-unused-state
		deltaJobCount: 0,
		deltaTime: 1,
		lastUpdateTime: moment().valueOf(), // eslint-disable-line react/no-unused-state
	};

	static getDerivedStateFromProps(nextProps, prevState) {
		const time = moment().valueOf();
		const nextJobCount = Map.isMap(nextProps.job) ? nextProps.job.get("progress_count", 0) : 0;

		return {
			lastUpdateTime: time,
			lastJobCount: nextJobCount,
			deltaTime: time - prevState.lastUpdateTime,
			deltaJobCount: nextJobCount - prevState.lastJobCount,
		};
	}

	componentDidMount() {
		this.props.init();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isUsingActiveJob === true && this.props.isUsingActiveJob === false) {
			this.props.getJob();
		}
	}

	render() {
		const { job, isDebug } = this.props;
		const { deltaJobCount, deltaTime } = this.state;

		const jobFound = Map.isMap(job);

		if (!jobFound) {
			return <div />;
		}

		let status = "";

		if (job.get("started") && !job.get("finished")) {
			status = "Running";
		} else if (job.get("started") && job.get("finished")) {
			status = "Completed";
		} else if (!job.get("started") && !job.get("finished")) {
			status = "Queued";
		}

		let indicator = <div />;

		if (status === "Running") {
			indicator = <RunningIndicator />;
		} else if (status === "Completed") {
			indicator = <Icon type="fa5" name={["fas", "check"]} size={26} />;
		} else if (status === "Queued") {
			indicator = <Icon type="fa5" name={["fal", "cog"]} size={26} />;
		}

		const jobPercent = (job.get("progress_count") / job.get("progress_total")) * 100;

		return (
			<section className="page-jobs-single" style={{}}>
				<section className="job-wrapper" style={{}}>
					<div className="animation-wrapper">
						<div
							className={`indicator ${status}`}
							style={{
								width: Config.animationSize,
								height: Config.animationSize,
							}}
						>
							{indicator}
						</div>
					</div>

					<div className={`status ${status}`}>
						<div className="status-label">{status}</div>
					</div>

					<div className="title">{job.get("title", "")}</div>

					<div className="progress-bar-wrapper">
						<ProgressBar value={jobPercent} color="green" />
					</div>

					{isDebug && status !== "Completed" ? (
						<div className="job-velocity">
							Job Velocity: {((deltaJobCount / deltaTime) * 1000).toFixed(2)} jobs per second
						</div>
					) : (
						""
					)}

					{status === "Completed" ? (
						<section className="text-content">
							<CompletedAction
								name={job.get("name")}
								jobID={job.get("_id")}
								redirectURL={job.get("redirectURL")}
							/>
						</section>
					) : (
						<div />
					)}
				</section>
			</section>
		);
	}
}

const mapStateToProps = (state) => {
	const activeJob = getActiveSingleJob(state);
	const nonActiveJob = getNonActiveSingleJob(state);

	const job = activeJob || nonActiveJob;

	return {
		job,
		isUsingActiveJob: !!activeJob,
		isDebug: getIsDebug(state),
	};
};
const mapDispatchToProps = (dispatch) => ({
	getJob: () => dispatch(getJob()),
	init: () => dispatch(initialize()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSingleJobPage);
